import { FC, useEffect, useState } from 'react'

import { Toast } from '../../compositions'
import { Toast as ToastInterface } from '../../types/toastTypes'
import { toastsWithFadingBehavior } from './helpers'

import './ToastsContainer.scss'

interface ToastProps {
    toasts: ToastInterface[];
    className?: string;
}

const Toasts: FC<ToastProps> = ({ toasts, className = '' }) => {
    const [toastsState, setToastsState] = useState<ToastInterface[]>([])

    useEffect((): void => {
        setToastsState(toastsWithFadingBehavior(toasts))
    }, [toasts])

    return (
        <div className={`toasts-container ${className}`}>
            {toastsState.map(toast => (
                <Toast
                    key={`${toast.createdOn}-${toast.text}`}
                    toast={toast}
                    className="toasts-container__toast"
                />
            ))}
        </div>
    )
}

export default Toasts
